import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Visibility } from '@material-ui/icons';
import { format, parseISO, subDays } from 'date-fns';

import { Modal, UnidataTable } from '~/components';
import { t } from '~/helpers';
import api from '~/services/api';
import {
  dataInRequest,
  recordFiltering,
} from '~/store/modules/alteracaoCentroCusto/actions';

import Form from './form';
import View from './view';

export default function AlteracaoCentroCusto() {
  const dispatch = useDispatch();
  const redux = useSelector((s) => s.alteracaoCentroCusto);
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!redux.loading) {
        dispatch(dataInRequest({ ...redux.params, pesquisalista: true }));
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [dispatch, redux.loading, redux.params]);

  const view = useCallback(async (row) => {
    try {
      setLoading(true);
      const { data } = await api.get(`alteracc/${row.idalteracaocentrocusto}`);
      modalRef.current.handleOpenModal({ data });
    } finally {
      setLoading(false);
    }
  }, []);
  const header = useMemo(
    () => [
      {
        id: 'datahorainiciosolicitacaoalteracaocentrocusto',
        label: t(
          's.operacao.historicorecalculaturno.datahorahistoricorecalculaturno'
        ),
        formatted: (v) => (v ? format(parseISO(v), 'dd/MM/yyyy HH:mm:ss') : ''),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
        },
      },
      {
        id: 'datahorafimsolicitacaoalteracaocentrocusto',
        label: t(
          's.operacao.historicorecalculaturno.datahorafimexecucaohistoricorecalculaturno'
        ),
        formatted: (v) => (v ? format(parseISO(v), 'dd/MM/yyyy HH:mm:ss') : ''),
      },
      {
        id: 'idveiculo',
        label: t('s.menu.cadastro.veiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'idcentrocusto',
        label: t('s.menu.cadastro.veiculo.centrocusto'),
        filter: { type: 'text' },
      },
      {
        id: 'strstatusalteracaocentrocusto',
        label: t('s.cadastro.veiculo.statusveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );
  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={dataInRequest}
        find={recordFiltering}
        actions={[
          {
            title: t('s.geral.visualizar'),
            action: view,
            icon: <Visibility />,
          },
        ]}
        update={false}
        delete={false}
        form={Form}
        keys="idalteracaocentrocusto"
        detach="idalteracaocentrocusto"
      />
      <Modal
        ref={modalRef}
        loading={loading}
        component={View}
        actions={[
          {
            label: t('s.geral.botaofechar'),
            callback: () => modalRef.current.handleCloseModal(),
            color: 'secondary',
            variant: 'outlined',
          },
        ]}
        title={t('s.menu.operacao.alteracaocentrocusto')}
        maxWidth="sm"
      />
    </>
  );
}
